import { render, staticRenderFns } from "./applyCase.vue?vue&type=template&id=baf5a8f8&scoped=true"
import script from "./applyCase.vue?vue&type=script&lang=js"
export * from "./applyCase.vue?vue&type=script&lang=js"
import style0 from "./applyCase.vue?vue&type=style&index=0&id=baf5a8f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf5a8f8",
  null
  
)

export default component.exports